<script lang="ts" setup>
const props = defineProps({
  error: Object,
})

const { t } = useLang()
const { locale } = useI18n()
const isNotFound = computed(() => props.error?.statusCode === 404)
const countdown = ref(3)
let countdownTimer: ReturnType<typeof setInterval> | undefined

const backToHome = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
  window.location.replace(`/${locale.value}/`)
}

useHead({
  title: t('home.b_error_404'),
  meta: [
    { name: 'keywords', content: t('common.b_tdk_keywords') },
    { name: 'description', content: t('common.b_tdk_description') },
    { name: 'author', content: t('common.b_author') },
    { name: 'copyright', content: t('common.b_company') },
  ],
  bodyAttrs: {},
  script: [],
  link: [],
})
onMounted(() => {
  if (isNotFound.value) {
    countdownTimer = setInterval(() => {
      if (countdown.value <= 1) {
        backToHome()
        return
      }
      countdown.value -= 1
    }, 1000)
  }

  if (process.client) {
    if (props.error) {
      console.log('error', props.error)

      try {
        const tq = window.tq
        // 手动上报错误
        if (tq) {
          tq.reportErr(props.error)
        }
      }
      catch (error) {

      }
    }
  }
})

onBeforeUnmount(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
})
</script>

<template>
  <defaultHeader />
  <div class="center-container">
    <div class="content">
      <p class="error_msg">
        {{ t('home.b_error_404') }}
      </p>
      <button v-if="isNotFound" class="back-home" type="button" @click="backToHome">
        {{ t('csEmail.feed_backtohome') }} ({{ countdown }}s)
      </button>
      <img class="error-img" src="//file.reshg.com/hopegoo/web-pc/images/404/img/seabed.png" alt="404">
    </div>
  </div>
  <defaultFooter />
</template>

<style lang="scss" scoped>
.center-container {
  background-color: white;

  .content {
    margin: 130px auto;

    position: relative;
    width: 1190px;
    background: #fff;
    text-align: center;
    color: #333;

    display: flex;
    flex-direction: column;

    .error_msg {
      position: absolute;
      top: 162px;
      left: 50%;

      text-align: center;
      font-size: 28px;
      color: #333;

      transform: translate(-50%, -50%);
    }

    .error-img {
      width: 100%;
      height: 100%;
    }

    .back-home {
      position: absolute;
      z-index: 1;
      top: 210px;
      left: 50%;
      width: 160px;
      height: 42px;
      border: 0;
      border-radius: 21px;
      background: #00c868;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      transform: translateX(-50%);
    }
  }
}
</style>
